module.exports = __webpack_public_path__ + "img/arvore.5dc5e444.svg";